import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-8 max-w-md mx-auto bg-white rounded-lg shadow-md" }

import { reactive } from "vue";
import { useRoute } from "vue-router";
import { useReservationStore } from "@/stores/reservationStore";
import axios from "axios";
import { toast } from "vue3-toastify";


export default /*@__PURE__*/_defineComponent({
  __name: 'ReservationForm',
  setup(__props) {

const route = useRoute();
const side = route.params.side as string;
const store = useReservationStore();
const API_BASE_URL = process.env.VUE_APP_API_BASE_URL;

const form = reactive({
  name: "",
  message: "",
  attendance: "",
});

async function submitForm() {
  if (!form.name || !form.attendance) {
    toast.warning("Nama dan Kehadiran wajib diisi");
    return;
  }

  try {
    await axios.post(`${API_BASE_URL}/${side}/reservasi`, {
      name: form.name,
      message: form.message,
      attendance: form.attendance,
    });

    toast.success("Reservasi berhasil dikirim!");

    form.name = "";
    form.message = "";
    form.attendance = "";

    await store.fetchReservations(side);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (err: any) {
    toast.error(err.message || "Gagal mengirim data");
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _cache[8] || (_cache[8] = _createElementVNode("h2", { class: "text-2xl font-bold mb-4" }, "Reservation Form", -1)),
    _createElementVNode("form", {
      onSubmit: _withModifiers(submitForm, ["prevent"]),
      class: "space-y-4"
    }, [
      _createElementVNode("div", null, [
        _cache[3] || (_cache[3] = _createElementVNode("label", { class: "block text-lg" }, "Nama:", -1)),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.name) = $event)),
          class: "p-2 border w-full rounded",
          required: ""
        }, null, 512), [
          [_vModelText, form.name]
        ])
      ]),
      _createElementVNode("div", null, [
        _cache[4] || (_cache[4] = _createElementVNode("label", { class: "block text-lg" }, "Pesan:", -1)),
        _withDirectives(_createElementVNode("textarea", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.message) = $event)),
          class: "p-2 border w-full rounded",
          rows: "3"
        }, null, 512), [
          [_vModelText, form.message]
        ])
      ]),
      _createElementVNode("div", null, [
        _cache[6] || (_cache[6] = _createElementVNode("label", { class: "block text-lg" }, "Konfirmasi Kehadiran:", -1)),
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.attendance) = $event)),
          class: "p-2 border w-full rounded",
          required: ""
        }, _cache[5] || (_cache[5] = [
          _createElementVNode("option", {
            value: "",
            disabled: ""
          }, "Pilih", -1),
          _createElementVNode("option", { value: "Hadir" }, "Hadir", -1),
          _createElementVNode("option", { value: "Tidak Hadir" }, "Tidak Hadir", -1),
          _createElementVNode("option", { value: "Masih Ragu" }, "Masih Ragu", -1)
        ]), 512), [
          [_vModelSelect, form.attendance]
        ])
      ]),
      _cache[7] || (_cache[7] = _createElementVNode("button", {
        type: "submit",
        class: "bg-blue-700 text-white px-4 py-2 rounded"
      }, " Submit ", -1))
    ], 32)
  ]))
}
}

})